import Vue from "vue";
import AxiosService from "@/services/AxiosService";
import IGlobalConfigServiceShop from "@/services/definition/IGlobalConfigServiceShop";
import {IGlobalConfigShop} from "@/models/global-config/GlobalConfigShopModels";

export default class AxiosGlobalConfigServiceShop extends AxiosService implements IGlobalConfigServiceShop {

	public static readonly BASE_URL = '/shop/global-config';

	protected defineBaseUrl(): string {
		return AxiosGlobalConfigServiceShop.BASE_URL;
	}

	public globalConfig(): Promise<IGlobalConfigShop> {
		return Vue.$axios.get<IGlobalConfigShop>(this.url()).then(res => res.data);
	}

}
